spec_version: "1.1"
id: mw-impuestos
slug: mw-impuestos
tipo_curso: monografico
nombre: "Impuestos sin dolor"
nombre_corto: "Impuestos"
descripcion_corta: "Entiende el IRPF, maximiza tus deducciones y haz la declaración con confianza. Casos prácticos para asalariados, autónomos y arrendadores."
idioma: es-ES
duracion_total_min: 150
audiencia: "Contribuyentes españoles que quieren entender y optimizar su declaración"
editor: "MentorWallet"
version_curso: "0.1.0"
fecha_publicacion: "2026-07-01"
categorias:
  - finanzas-personales
  - fiscal
modalidad_predominante: mixto
modo_navegacion: "libre"
modulos:
  - 01-irpf-basico
  - 02-deducciones
  - 03-declaracion-paso-a-paso
  - 04-casos-especiales
